var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"primary-box"},[_c('div',{staticClass:"primary-text"},[_c('div',[_vm._v("预选积分")]),_c('div',{staticClass:"primary-num"},[_vm._v(_vm._s(_vm.primary)+"分")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }